class Response {
  constructor() {
    this.success = false;
    this.data = null;
    this.total = 0;
    this.message = '';
  }

  isSuccess() {
    return true === this.success;
  }

  setSuccess(success) {
    this.success = success;

    return this;
  }

  getData() {
    return this.data;
  }

  setData(data) {
    this.data = data;

    return this;
  }

  getTotal() {
    return this.total;
  }

  setTotal(total) {
    this.total = total;

    return this;
  }

  getMessage() {
    return this.message;
  }

  setMessage(message) {
    this.message = message;

    return this;
  }
}

export default Response;
